type ContactTimeLike =
  | string
  | {
      from?: string
      to?: string
      start?: string
      end?: string
      fromTime?: string
      toTime?: string
    }
  | null
  | undefined

export function formatPreferredContactTime(time: ContactTimeLike): string {
  if (time == null) return 'Not specified'
  if (typeof time === 'string') {
    const trimmed = time.trim()
    return trimmed || 'Not specified'
  }
  const from = time.from ?? time.start ?? time.fromTime
  const to = time.to ?? time.end ?? time.toTime
  if (from && to) return `${from} – ${to}`
  if (from) return from
  if (to) return to
  return 'Not specified'
}

export function getPreferredContactTime(feedback: {
  time?: ContactTimeLike
  preferred_contact_time?: ContactTimeLike
}): ContactTimeLike {
  return feedback?.time ?? feedback?.preferred_contact_time
}
